import React, { useEffect, useState } from "react";
import FrontVideo from "../../components/homevideo";
import HeaderTitle from "../../components/headerTitle";
import ManagedCloudServices from "../../assest/images/IshanManagedServices.png";
import axios from "axios";
import { API_BASE_URL } from "../../config/config";
import WhatWeOffer from "../../components/CommonSections/WhatWeOffer";
import Advantage from "../../components/CommonSections/Advantage";
import PageLoader from "../../components/home/pageload";
import ClientExperiences from "../../components/home/client-experiences";
import MetaTag from "../../components/CommonSections/MetaTag";
import { Link } from "react-router-dom";
import SubServiceSchema from "../../components/CommonSections/subServicesSchema";
import Accordion from "../../components/accordion";

export default function ManagedServices() {

     const handleClick = () => {
          window.scrollTo(0, 0);
     }
     const [managedServiceData, setManagedServiceData] = useState(null);
     const [settingResponse, setSettingResponse] = useState(null);

     useEffect(() => {
          const requestData = {
               "service_tag": "managed_service"
          };

          axios.post(`${API_BASE_URL}/api/managedservices/getManagedServices`, requestData).then((response) => {

               setManagedServiceData(response);

               const generalSettingsData = response?.data?.data?.general_settings?.general_settings_data;
               const networkServicesSettingsData = generalSettingsData.find((item) => item.tag === "managed_service") || null;
               const networkServicesSettingsResponse = JSON.parse(networkServicesSettingsData?.response || "{}");

               setSettingResponse(networkServicesSettingsResponse);
          }).catch((error) => {
               console.error("Error fetching data:", error);
          })
     }, [])

     const getFaqSchema = () => {
          const faqData = managedServiceData?.data?.data?.managed_services?.faq_info_data || [];
          return {
               "@context": "https://schema.org",
               "@type": "FAQPage",
               mainEntity: faqData.map(faq => ({
                    "@type": "Question",
                    name: faq.question,
                    acceptedAnswer: {
                         "@type": "Answer",
                         text: faq.answerData || faq.answer.replace(/<[^>]*>?/gm, '')
                    }
               }))
          };
     };

     return (
          <>
               {managedServiceData === null ? (
                    <PageLoader />
               ) : (
                    <>
                    <SubServiceSchema title={managedServiceData?.data?.data?.managed_services?.managed_services_banner_data
                              [0].title} url='https://ishantechnologies.com/systems-integration/managed-services' parentTitle='System Integration' parentUrl='https://ishantechnologies.com/systems-integration' />
                    <MetaTag data={managedServiceData} pageKey="managed_services"/>
                         <div className="page_heading responsive_heading">
                              <div className="container">
                                   <HeaderTitle headerTitledata={managedServiceData} pageKey="managed_services" />
                              </div>
                         </div>
                         <div className={`video hero-banner ${
                         !managedServiceData?.data?.data?.managed_services?.managed_services_banner_data[0]?.banner_title &&!managedServiceData?.data?.data?.managed_services?.managed_services_banner_data[0]?.banner_img_desc 
                              ? 'no-content' 
                              : ''
                         }`}
                         >
                              <FrontVideo homeData={managedServiceData} pageKey="managed_services" />
               
                              <div className="banner-content ">
                                   {managedServiceData?.data?.data?.managed_services?.managed_services_banner_data
                              [0]?.banner_title && (
                                   <h2 className='home-heading'>
                                             {managedServiceData?.data?.data?.managed_services?.managed_services_banner_data
                              [0].banner_title}
                                   </h2>
                                   )}

                                   {managedServiceData?.data?.data?.managed_services?.managed_services_banner_data
                              [0]?.banner_img_desc && (
                                   <p className="para">
                                             {managedServiceData?.data?.data?.managed_services?.managed_services_banner_data
                              [0].banner_img_desc}
                                   </p>
                                   )}

                                   {managedServiceData?.data?.data?.managed_services?.managed_services_banner_data
                              [0]?.button_img_name && (
                                   <a href={managedServiceData?.data?.data?.managed_services?.managed_services_banner_data
                              [0].button_url}>
                                             <button className="button hero-btn">
                                             {managedServiceData?.data?.data?.managed_services?.managed_services_banner_data
                              [0]?.button_img_name}
                                             </button>
                                   </a>
                                   )}
                              </div>
                         </div>

                         <div className="empowering section-space spin-wrap">
                              <div className="spin-round-wrap">
                                   <div className="spin-round color-navy-blue">
                                        <span className='ballDot1'>1</span>
                                        <span className='ballDot2'>2</span>
                                        <span className='ballDot3'>3</span>
                                        <span className='ballDot4'>4</span>
                                   </div>
                              </div>

                              <div className="container">
                                   <div className="empowering-inner">
                                        <div className="empowering-left">
                                             {<img src={ManagedCloudServices} alt="Managed Services" height={60} width={60} loading="lazy"/>}
                                        </div>
                                        <div className="empowering-right" dangerouslySetInnerHTML={{ __html: managedServiceData?.data?.data?.managed_services?.managed_services_information_data[0]?.description }}>
                                        </div>
                                   </div>
                              </div>

                              <div className="spin-round-wrap">
                                   <div className="spin-round">
                                        <span className='ballDot1'>1</span>
                                        <span className='ballDot2'>2</span>
                                        <span className='ballDot3'>3</span>
                                        <span className='ballDot4'>4</span>
                                   </div>
                              </div>
                         </div>

                         <div className="weoffer-bgdark">
                              <WhatWeOffer title={settingResponse?.what_we_offer} data={managedServiceData?.data?.data?.managed_services?.managed_services_offer_data} />
                         </div>

                         <Advantage title={settingResponse?.advantages} data={managedServiceData?.data?.data?.managed_services?.managed_services_advantages_data} />

                         <div className="client-experiences section-space">
                              <ClientExperiences homeData={managedServiceData} pageKey="managed_services" tag="managed_service" />
                         </div>

                         {managedServiceData?.data?.data?.managed_services?.faq_info_data?.length > 0 && (
                            <div className="frequently section-space">
                                <div className="container">
                                    <h2 className="supercharge-heading">Frequently Asked Questions (FAQs)</h2>

                                    <script
                                        type="application/ld+json"
                                        dangerouslySetInnerHTML={{ __html: JSON.stringify(getFaqSchema()) }}
                                    />

                                    <Accordion items={managedServiceData?.data?.data?.managed_services?.faq_info_data} />
                                </div>
                            </div>
                          )}

                         <div className="supercharge supercharge-left">
                              <div className="container">
                                   <h2 className="supercharge-heading">{managedServiceData?.data?.data?.managed_services?.managed_services_cta_banner_data[0]?.title}</h2>
                                   <div className="supercharge-btns">
                                        {managedServiceData?.data?.data?.managed_services?.managed_services_cta_banner_data[0]?.button_title_1 &&
                                             <Link to={managedServiceData?.data?.data?.managed_services?.managed_services_cta_banner_data[0]?.button_url_1}>
                                                  <button className="getintouch" onClick={handleClick}>{managedServiceData?.data?.data?.managed_services?.managed_services_cta_banner_data[0]?.button_title_1?.toUpperCase()}</button>
                                             </Link>
                                        }
                                        {managedServiceData?.data?.data?.managed_services?.managed_services_cta_banner_data[0]?.button_title_2 &&
                                             <Link to={managedServiceData?.data?.data?.managed_services?.managed_services_cta_banner_data[0]?.button_url_2} target="_blank">
                                                  <button className="getintouch" onClick={handleClick}>{managedServiceData?.data?.data?.managed_services?.managed_services_cta_banner_data[0]?.button_title_2?.toUpperCase()}</button>
                                             </Link>
                                        }
                                   </div>
                              </div>
                         </div>
                    </>
               )}
          </>
     );
}

